<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="WalletHistory" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { WalletHistoryProps } from './WalletHistory.ts';
import WalletHistory from './WalletHistory.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-wallet-history';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<WalletHistoryProps>();
const changableProps = useChangableProps(componentName, props);

</script>
